const doc = [({"ko":({"adminConstantHotelPushMessageGroupPlatformType":({"allPlatforms":"모든 플랫폼", "line":"LINE"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;